var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6271 0 24 5.37288 24 12C24 18.6271 18.6269 24 12 24C5.37312 24 0 18.6286 0 12C0 5.37144 5.37216 0 12 0Z",
    fill: "#627EEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0224 3.5625L11.9092 3.94706V15.1051L12.0224 15.218L17.2017 12.1565L12.0224 3.5625Z",
    fill: "#C0CBF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0232 3.5625L6.84375 12.1565L12.0232 15.218V9.80223V3.5625Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0223 16.1972L11.9585 16.275V20.2496L12.0223 20.4359L17.2048 13.1372L12.0223 16.1972Z",
    fill: "#C0CBF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0232 20.4359V16.1972L6.84375 13.1372L12.0232 20.4359Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 15.2239L17.2018 12.1624L12.0225 9.80811V15.2239Z",
    fill: "#8197EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84375 12.1624L12.0232 15.2239V9.80811L6.84375 12.1624Z",
    fill: "#C0CBF6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.0db384ac498af07101ad92c1f5a25472.svg";
export { ForwardRef as ReactComponent };